import styled from 'styled-components';

export const StrippedButtonContainer = styled.button`
  border: none;
  background-color: unset;

  &:hover {
    cursor: pointer;
  }
`;
